document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.review_container_hoox').forEach(function(container) {
    var section = container.closest('.hoox_review_custom_main');
    if (!section) return;

    var swiper = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: section.querySelector('.hoox-swiper-arrow-next-customreviewsec'),
        prevEl: section.querySelector('.hoox-swiper-arrow-prev-customreviewsec'),
      },
      pagination: {
        el: section.querySelector('.swiper-pagination-customreviewsec'),
        clickable: true,
      },
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        0: {
          slidesPerView: 1,
          spaceBetween: 10
        }
      }
    });
  });
});
